import { IntegrationServiceId } from '../../../../../common/integrations'
import { ClickNavigationProps } from '../../../../../components/NavigationWithSideBar/ClickNavigation'
import { ContactSyncSettings } from './ContactSyncSettings'
import { CRMIntegrationTaskSettings } from '../CRMIntegrationTaskSettings'

export const SalesforceBasedSpecificSettings = (serviceId: IntegrationServiceId): ClickNavigationProps[] => {
  const baseSFSpecificSettings: ClickNavigationProps[] = [
    { id: 'contactSync', label: 'Contact Sync', content: () => <ContactSyncSettings serviceId={serviceId} /> },
    { id: 'task', label: 'Task', content: () => <CRMIntegrationTaskSettings serviceId={serviceId} /> },
  ]
  return baseSFSpecificSettings
}
